import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterModule } from '@angular/router';
import { UserProfileComponent } from 'src/app/components/user/user-profile.component';
import { ContractsComponent } from 'src/app/components/contracts/contract-list/contracts-list.component';
import { DashboardComponent } from 'src/app/components/dashboard/regular-dashboard/dashboard.component';
import { MarketDealersDashboardComponent } from 'src/app/components/dashboard/market-dealers-dashboard/market-dealers-dashboard.component';
import { GroupingViewComponent } from 'src/app/components/groupings/grouping-view/grouping-view.component';
import { ContractsViewComponent } from 'src/app/components/contracts/contracts-view/contracts-view.component';

export const routes: Route[] = [
    {
        path: '',
        component: DashboardComponent,
        data: { pageTitle: 'BEGINNING' }
    },
    {
        path: 'market-dealers',
        data: { pageTitle: 'MARKET_DEALERS' },
        children: [
            {
                path: 'dashboard',
                component: MarketDealersDashboardComponent,
                data: { pageTitle: 'Dashboard' }
            },
            {
                path: 'hedging',
                component: GroupingViewComponent,
                data: { pageTitle: 'Hedging' },
                children: [
                    {
                        path: 'price',
                        data: { pageTitle: 'PRICE' },
                        loadChildren: () => import('src/app/components/prices/prices.module').then((m) => m.PricesModule)
                    }
                ]
            },
            {
                path: 'spot',
                component: GroupingViewComponent,
                data: { pageTitle: 'Spot' },
                children: [
                    {
                        path: 'price',
                        data: { pageTitle: 'PRICE' },
                        loadChildren: () => import('src/app/components/prices/prices.module').then((m) => m.PricesModule)
                    }
                ]
            }
        ]
    },
    {
        path: 'profile',
        component: UserProfileComponent,
        data: { pageTitle: 'MY_PROFILE' }
    },
    {
        path: 'tickets',
        data: { pageTitle: 'SUPPORT_REQUESTS' },
        loadChildren: () => import('src/app/components/supportRequests/tickets.module').then((m) => m.TicketModule)
    },
    {
        path: 'contracts',
        data: { pageTitle: 'CONTRACTS' },
        loadChildren: () => import('src/app/components/contracts/contracts.module').then((m) => m.ContractsModule)
    },
    {
        path: 'proposals',
        data: { pageTitle: 'PROPOSALS' },
        loadChildren: () => import('src/app/components/proposals/proposals.module').then((m) => m.ProposalsModule)
    }
]

@NgModule({
    declarations: [],
    imports: [ RouterModule.forChild(routes) ],
    exports: [ RouterModule ],
    providers: [],
})
export class AuthenticatedLayoutRoutingModule {}